import styled from 'styled-components';
function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className="card-inner active">
      <Width className="row ">
        <div className="card-wrap col col-m-12 col-t-12 col-d-8 col-d-lg-6">
          <Wrap>
            <p>
              Developed by{' '}
              <span>
                <a href="http://sharooqsalaudeen.github.io/">
                  Sharooq Salaudeen
                </a>
              </span>
            </p>
            <p>Copyright <span>© {year}</span></p>
          </Wrap>
        </div>
      </Width>
    </div>
  );
}

export default Footer;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding: 0px 40px;

  a {
    color: #ffffff;
  }

  span {
    display: inline-block;
  }

  @media (max-width: 679px) {
    padding: 0px 20px;
  }
`;

const Width = styled.div`
  width: 100%;
`;
